// extracted by mini-css-extract-plugin
module.exports = {"home-page-mosaic":"Mosaic_home-page-mosaic__RxIUj","picture":"Mosaic_picture__LEysR","title":"Mosaic_title__A_s0h"};